module.exports = __webpack_public_path__ + "static/knowledgebase-06696c25187f68e478bdd85b961d306b.jpg";